import { Layout } from "../components/layout/Layout";
import { InputBox } from "../components/analyse/InputBox";
import { LoadingOverlay } from "../components/LoadingIndicator";
import { ResultsBox } from "../components/ResultsBox";
import { API } from "../helpers/api";
import { MAX_TEXT_WORDS, countWords } from "../helpers/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "../translations/LanguageContext";

export function Compare() {
    const { t } = useTranslation();
    const [text1, setText1] = useState("");
    const [text2, setText2] = useState("");
    const [results1, setResults1] = useState(null);
    const [results2, setResults2] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const isOverLimit = countWords(text1) > MAX_TEXT_WORDS || countWords(text2) > MAX_TEXT_WORDS;

    // Test API is functioning - return error message to user otherwise
    function testAPI() {
        API.get("/health")
            .then(() => setErrorMessage(null))
            .catch(err => {
                console.error(err);
                setErrorMessage(t("common.errors.serviceUnavailable"));
            });
    }

    // Submit API requests to get the comparison results
    function compareTexts() {
        if (!text1.trim() || !text2.trim()) return;
        if (isOverLimit) {
            setErrorMessage(t("inputBox.tooLong", { max: MAX_TEXT_WORDS }));
            return;
        }
        setLoading(true);
        setErrorMessage(null);
        Promise.all([
            API.post("/analyse", { text: text1 }),
            API.post("/analyse", { text: text2 }),
        ])
            .then(([r1, r2]) => {
                setResults1(r1.data);
                setResults2(r2.data);
            })
            .catch(err => {
                console.error(err);
                setErrorMessage(t("common.errors.analysisFailed"));
            })
            .finally(() => setLoading(false));
    }

    // test api on page load
    useEffect(() => {
        testAPI()
    }, []);

    return (
        <Layout>
            {loading && <LoadingOverlay message={t("loading.compareMessage")} />}

            {/* Error Message */}
            {errorMessage && (
                <div className="error-banner" role="alert">
                    {errorMessage}
                </div>
            )}

            <section className="page-header compare-header">
                <div className="page-header-left">
                    <h1 className="page-title">{t("comparePage.title")}</h1>
                    <h2 className="page-subtitle">{t("comparePage.subtitle")}</h2>
                </div>
            </section>

            <section className="results-boxes">
                <InputBox name="comparison-1" text={text1} setText={setText1} />
                <InputBox name="comparison-2" text={text2} setText={setText2} />
            </section>

            <button
                className="action-btn action-btn--full compare-btn"
                onClick={compareTexts}
                disabled={!text1.trim() || !text2.trim() || isOverLimit}
            >
                {t("comparePage.button")}
            </button>

            {results1 && results2 && (
                <>
                    {/*<ComparisonTable data1={results1} data2={results2} />*/}
                    <section className="results-boxes results-boxes--compare">
                        <ResultsBox data={results1} />
                        <ResultsBox data={results2} />
                    </section>
                </>
            )}
        </Layout>
    );
}
